import * as React from 'react';

import { ConnectedQueryParamUpdateProvider } from '~src/bootstrap/routerHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedSiteBroadcastsSpace } from './ConnectedSiteBroadcastsSpace';

export interface SiteBroadcastsSpaceProviderProps {
    readonly siteName: string;
    readonly routeLocationPath: string;
    readonly routeLocationSearch: string;
}

const SiteBroadcastsSpaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'broadcasts',
    subspaceName: undefined
};

export const SiteBroadcastsSpaceProvider: React.FunctionComponent<SiteBroadcastsSpaceProviderProps> = (props) => {
    return (
        <ConnectedSpaceInfoProvider spaceInfo={SiteBroadcastsSpaceInfo}>
            <ConnectedQueryParamUpdateProvider
                routeLocationPath={props.routeLocationPath}
                routeLocationSearch={props.routeLocationSearch}
                shouldUpdateBreadcrumbs={false}
                shouldUpdateContentTypes={false}
                shouldUpdateFilters={false}
                shouldUpdateSort={true}
            >
                <ConnectedSiteBroadcastsSpace
                    siteName={props.siteName} />
            </ConnectedQueryParamUpdateProvider>
        </ConnectedSpaceInfoProvider>
    );
};
